import { motion } from "framer-motion";
import { STEPS } from "../../data/product";

export const HowTo = () => (
  <section className="max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-28" data-testid="howto-section">
    <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">How To Use</p>
    <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B] mb-14">
      Three steps. <span className="italic text-[#3A2A25]">Done.</span>
    </h2>
    <div className="grid sm:grid-cols-3 gap-8">
      {STEPS.map((step, i) => (
        <motion.div
          key={step.num}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          className="bg-[#FFFDF9] rounded-xl p-8 border border-[rgba(58,42,37,0.08)] shadow-[0_4px_20px_rgba(58,42,37,0.05)]"
          data-testid={`howto-step-${step.num}`}
        >
          <span className="w-10 h-10 rounded-full bg-[#3A2A25] text-white font-serif-display text-lg flex items-center justify-center">{step.num}</span>
          <h3 className="font-serif-display text-2xl text-[#2B1F1B] mt-5 mb-2">{step.title}</h3>
          <p className="text-sm font-light leading-relaxed text-[#756A64]">{step.text}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
